// app/kirei-tube/[slug]/page.tsx
'use client';

import { API_YOUTUBE_VIDEOS } from '@/constant/apiRout';
import CartButton from '@/features/home/Flash_sales/components/CartButton';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import { ArrowLeft01Icon, ArrowRight01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import Link from 'next/link';

const aspectRatioStyle = (url: string) => {
  try {
    const uri = new URL(url);
    const height = parseInt(uri.searchParams.get('height') || '9', 10);
    const width = parseInt(uri.searchParams.get('width') || '16', 10);
    const aspectRatio = width / height;
    console.log(height, width, aspectRatio);

    return { aspectRatio: `${aspectRatio}`, width: width };
  } catch {
    return { aspectRatio: '16/9', width: '100%' };
  }
};

const formatNumber = (num?: number) => {
  if (!num) return '0';
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export default function VideoPage({ params }: any) {
  const { slug } = params;

  const { data: video, isLoading } = useFetcherCSR(API_YOUTUBE_VIDEOS(slug));
  console.log(video);

  if (isLoading || !video)
    return (
      <div className="container padding-bottom padding-top">Loading...</div>
    );

  return (
    <main className="main about">
      <div className=" padding-bottom padding-top">
        <div className="container">
          <div className="row g-4 justify-content-center">
            <div className="col-lg-10">
              <article className="post position-relative p-4 p-xl-5">
                <figure
                  className={`d-flex justify-content-center post-media post-video ${
                    video.data.orientation === 'portrait' ||
                    video.data.orientation === 'shorts'
                      ? 'bg-dark'
                      : ''
                  }`}
                >
                  {video.prev_video?.slug && (
                    <Link href={`/kirei-tube/${video.data.prev_video.slug}`}>
                      <span className="btn-nav btn-nav__prev trk-btn position-absolute">
                        <HugeiconsIcon icon={ArrowLeft01Icon} />
                      </span>
                    </Link>
                  )}
                  {video.next_video?.slug && (
                    <Link href={`/kirei-tube/${video.data.next_video.slug}`}>
                      <span className="btn-nav btn-nav__next position-absolute">
                        <HugeiconsIcon icon={ArrowRight01Icon} />
                      </span>
                    </Link>
                  )}
                  <iframe
                    style={aspectRatioStyle(video.data.video)}
                    className={video.data.orientation}
                    src={video.data.video}
                    title="Video Player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </figure>

                <div className="post-header pt-4 pb-5 border-top mt-5">
                  <div className="post-title">
                    <span className="btn-video btn-iframe fw-medium fs-5">
                      {video?.data?.title}
                    </span>
                  </div>
                </div>

                <div className="post-body">
                  <div className="post-meta">
                    {video.data.statistics?.[0]?.likeCount && (
                      <span className="post-views">
                        {formatNumber(video.data.statistics[0].likeCount)} Views
                      </span>
                    )}
                  </div>
                  <div className="post-details">
                    {video.data.short_description && (
                      <p
                        dangerouslySetInnerHTML={{
                          __html: video.data.short_description,
                        }}
                      />
                    )}
                  </div>
                </div>

                <div className="row g-4">
                  {video.data.products?.map((item: any) => ( 
                    <div key={item.id} className="col-lg-6">
                      <div className="recommend-product">
                        <div className="recommend-product-inner">
                          <div className="recommend-product-thumb">
                            <Link href={`/product/${item.slug}`}>
                              <img
                                alt={item.name}
                                src={item.pictures[0]?.url}
                                className="img-fluid"
                              />
                            </Link>
                          </div>
                          <div className="recommend-product-content">
                            <h6 className="title fw-medium">
                              <Link href={`/product/${item.slug}`}>
                                {item.name}
                              </Link>
                            </h6>
                            <div className="price-box d-flex justify-content-between align-items-center flex-wrap">
                              <span>
                                <span className="old-price fw-medium">
                                  ৳{item.sale_price}
                                </span>
                                {item.price > item.sale_price && (
                                  <span className="product-price fw-medium">
                                    {' '}
                                    / <del>৳{item.price}</del>
                                  </span>
                                )}
                              </span>
                              <CartButton product={item} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
